<template>
<div>
  <h5 class="text-inside-line"><span>{{ $t('now') }}</span></h5>
  <CurrentData :query="query"></CurrentData>
  <h5 class="text-inside-line"><span>{{ $t('control') }}</span></h5>
  <SubstationControl></SubstationControl>
  <h5 class="text-inside-line"><span>{{ $t('selected_date') }}</span></h5>
  <SelectDataRange @queryChanged="queryChangedHandler"></SelectDataRange>
  <SummaryChart></SummaryChart>
  <BatteryOccupation></BatteryOccupation>
  <BatterySamplesChart></BatterySamplesChart>
<!--   <SamplesChart :device_type="'battery'"></SamplesChart> -->
  <SamplesChart :device_type="'consumption'"></SamplesChart>
</div>
</template>

<script>
import CurrentData from './CurrentData.vue'
import SelectDataRange from './SelectDataRange.vue'
import SummaryChart from './SummaryChart.vue'
import BatteryOccupation from './BatteryOccupation.vue'
import SubstationControl from './SubstationControl.vue'
import BatterySamplesChart from './BatterySamplesChart.vue'
import SamplesChart from './SamplesChart.vue'

export default {
  name: 'Home',
  components: {
    CurrentData,
    SelectDataRange,
    SummaryChart,
    BatteryOccupation,
    BatterySamplesChart,
    SubstationControl,
    SamplesChart
  },
  data(){
    return {
      query: {},
    }
  },
  methods: {
    queryChangedHandler: function(query){
      this.query = query
    }
  },
  computed: {
    range: function(){
        return this.$store.getters.selected_range
    },
    current_page: function(){
        return this.$route.name
    }, 
    has_battery: function(){
      if (this.$store.getters.user_isAdmin) return this.$store.getters.remote_user_bess
      return this.$store.getters.user_bess
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.text-inside-line {
  position:relative;
  margin-top: 20px;
  text-align: center;
}
.text-inside-line::before {
  content: "";
  display: block;
  border-top: solid 1px #8d8888;
  width: 100%;
  height: 1px;
  position: absolute;
  top: 50%;
  z-index: 1;
}
.text-inside-line > span {
  background: #f7f8fb;
  padding: 0 20px;
  position: relative;
  z-index: 5;
  text-align: center;
}
</style>